import reviews from './reviews';
import reviewsInfo from './reviewsInfo';
import reviewsFilters from './reviewsFilters';
import dealerId from './dealerId';
import storeError from './storeError';
import page from './page';

const root = {
	reviews,
	reviewsInfo,
	reviewsFilters,
	dealerId,
	storeError,
	page
};

export default root;
